<div
    class="app-wrapper"
    libAdjustContentTopPadding
    [isHeaderHidden]="isHeaderHidden()"
    [ngClass]="{ 'is-hidden': isHeaderHidden() }"
>
    <div class="headers">
        <lib-top-header (clickLogo)="goHome()" (headerHidded)="headerHidden($event)"></lib-top-header>

        @if (!hideNavHeader()) {
            <div
                libHideHeaderWithHeight
                [omitScreens]="['desktop']"
                (isHeaderHidden)="headerHidden($event)"
                (libFocusOutside)="!isTabletOrLower() && navigationMenu.closeMenu()"
                (mouseleave)="!isTabletOrLower() && navigationMenu.closeMenu()"
            >
                <lib-navigation-menu #navigationMenu [actions]="navigationMenuActions()" />
            </div>
        }
        @if (bannerShown()) {
            <lib-snackbar class="notification" />
        }
    </div>
    <div class="theme-container main" style="max-width: none">
        <router-outlet></router-outlet>
    </div>
</div>
<lib-cookie-policy></lib-cookie-policy>

<footer>
    <lib-footer (clickLogo)="goHome()"></lib-footer>
    <lib-bottom-footer></lib-bottom-footer>
</footer>

<ng-template #categoriesActionTemplate>
    <lib-navigation-links
        class="box-container category-links"
        #categoriesPanel
        headerTitle="Categories"
        [navigationTree]="navigationTree()"
    >
        @if (brandBanners().length) {
            <div class="navigation-links__brands" body>
                @for (image of brandBannersView(); track image.brandId) {
                    <div class="navigation-links__brand">
                        <lib-background-overlay [imageUrl]="image.url">
                            <lib-brand
                                [ariaLabel]="image.brandName"
                                [brandName]="image.brandName"
                                [fallbackColor]="fallbackColor()"
                                [fallbackFontSize]="fallbackFontSize()"
                                [maxWidth]="150"
                                [url]="image.brandLogoUrl"
                                (libAccessibleClick)="onClickBrand(image.brandId, image.brandName)"
                            />
                        </lib-background-overlay>
                    </div>
                }
            </div>
        }
    </lib-navigation-links>
</ng-template>

<ng-template #brandActionTemplate>
    <lib-brands-list #brandsPanel [brands]="brands()" (closeAction)="closeNavigationMenu()" />
</ng-template>

<ng-template #searchActionTemplate>
    <lib-search-panel class="box-container" #searchPanel (close)="closeNavigationMenu()" />
</ng-template>
